import React from 'react';
import PropTypes from 'prop-types';
import BaseTable from './shared/BaseTable';
import { cellOperation, headerOperation } from '../helpers/tables';

const CreditPolicyDetailBeneficiarios = ({beneficiarios}) => {
  const columns = [
    {
      Header: headerOperation('RUT'),
      id: 'rut',
      accessor: i => cellOperation(i.cliente.rut),
      minWidth: 100,
      sortable: false,
    },
    {
      Header: headerOperation('Nombre'),
      id: 'nombre',
      accessor: i => cellOperation(i.cliente.nombre),
      minWidth: 200,
      sortable: false,
    }
  ];

  return (
    <BaseTable columns={columns} data={beneficiarios} />
  );
};

CreditPolicyDetailBeneficiarios.propTypes = {
  beneficiarios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    nombre: PropTypes.string,
  })).isRequired,
};

export default CreditPolicyDetailBeneficiarios;
